import type { ReactNode } from 'react';
import type { IconButtonProps } from '@mui/material';

export enum HealthStatus {
  SAFE = 'SAFE',
  MONITORING = 'MONITORING',
  CRITICAL = 'CRITICAL',
}

export interface ViewTypeAction {
  id: string;
  label: string;
  icon?: ReactNode;
  tooltip?: string;
  color?: IconButtonProps['color'];
  variant?: 'contained' | 'outlined';
  onClick?: () => void;
  disabled?: boolean;
}
